import React, {useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import {ProductInListMapType, ProductInSearchParamType} from "../../../../pages/product/internal/list/interface";
import PaginationSub from "../../pagination/PaginationSub";
import {InvListElementType, InvListMapType, InvSearchParamType} from "../../../../pages/inventory/inv/list/interface";
import {invListElementInit, invSearchParamInit} from "../../../../pages/inventory/inv/list/state";
import {useReadInventoryAtIncoming} from "../hooks/useReadInventoryAtIncoming";
import {useReadInvDetail} from "../../../../pages/inventory/inv/detail/hooks/useReadInvDetail";
import {InvDetailType} from "../../../../pages/inventory/inv/detail/interface";
import DisplayNumber from "../../number/DisplayNumber";

/**
 * 주소 검색 모달
 * @param props
 * @returns
 */
const SearchInventoryInner = ({
                                  confirmCallback,
                                  cancelCallback,
                                  modalDepth
                              }: ModalInnerConfirmType<InvDetailType>) => {
    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] =
        useState<InvSearchParamType>(invSearchParamInit);

    const [selectItem, setSelectItem] = useState<InvListElementType>(invListElementInit);

    const {data} = useReadInventoryAtIncoming({param: searchOption});
    const {data: invDetail} = useReadInvDetail({id: selectItem.inventoryId})

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<ProductInSearchParamType> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth)
    }

    const onConfirm = () => {
        if (selectItem.inventoryId !== 0) {
            confirmCallback(invDetail);
            onClose()
        } else {
            handleModal({
                isOpen: true,
                contents: "재고를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1
            })
        }
    }

    const onCancel = () => {
        onClose()
        cancelCallback && cancelCallback()
    }

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value={"1"}>전체</option>
                    <option value={"2"}>벤더</option>
                    <option value={"3"}>카테고리</option>
                    <option value={"4"}>품목</option>
                    <option value={"5"}>규격</option>
                    <option value={"6"}>중분류</option>
                    <option value={"7"}>대분류</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal">
                <thead>
                <tr>
                    <th rowSpan={2}></th>
                    <th rowSpan={2} style={{width: "7%"}}>벤더</th>
                    <th rowSpan={2} style={{width: "7%"}}>카테고리</th>
                    <th rowSpan={2}>품목</th>
                    <th rowSpan={2} style={{width: "15%"}}>규격</th>
                    <th rowSpan={2} style={{width: "7%"}}>대분류</th>
                    <th rowSpan={2} style={{width: "9%"}}>중분류</th>
                    <th rowSpan={2} style={{width: "6%"}}>환종</th>
                    <th rowSpan={2} style={{width: "7%"}}>단위</th>
                    <th rowSpan={2} style={{width: "7%"}}>재고</th>
                </tr>
                </thead>
                <tbody>
                {(data as InvListMapType)?.inventoryList?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data as InvListMapType)?.inventoryList?.map((el) => {
                        return (
                            <tr className={`clickable ${el.inventoryId === selectItem?.inventoryId ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(el)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            checked={selectItem.inventoryId === el.inventoryId}
                                            onClick={() => setSelectItem(el)}
                                        />
                                    </div>
                                </td>
                                <td className="text-center">{el.vendor}</td>
                                <td className="text-center">{el.category}</td>
                                <td className="text-center">{el.new_txt_nm_item}</td>
                                <td className="text-center">{el.new_txt_stnd_item}</td>
                                <td className="text-center">{el.majorCategory}</td>
                                <td className="text-center">{el.subCategory}</td>
                                <td className="text-center">{el.currency}</td>
                                <td className="text-center">{el.inventoryUnit}</td>
                                <td className="text-center"><DisplayNumber value={el.inventoryAmount}/></td>
                            </tr>
                        );
                    })
                )}
                </tbody>
            </table>

            <PaginationSub totalCount={(data as ProductInListMapType)?.totalCount ?? 0}
                           currentPage={searchOption.pageNo}
                           onChangeCallback={(i) => setSearchOption({...searchOption, pageNo: i})}/>

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};

export default SearchInventoryInner;
